import React from "react";
import ByzTitleBox from "../component/title-box";
import { Box, Card, Grid } from "@mui/material";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import FormFiller from "../component/form-filler";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
function PageThere() {
  const { t } = useTranslate();
  return (
    <Card sx={{ marginBottom: "5px" }}>
      <ByzTitleBox
        title={
          t("safe-birth-control-form.form-type") +
          " " +
          t("safe-birth-control-form.after-birth")
        }
      />

      <FormFiller />

      <ByzTitleBox title={t("safe-birth-control-form.complication-other")} />

      <Grid
        item
        xs={12}
        container
        spacing={3}
        sx={{ display: "flex", flexWrap: "wrap" }}
      >
        <Grid item sm={6} xs={12} md={4} xl={3}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.labor-atively")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={3}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.abnormal-bleeding")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          margin: "8px",
          p: 2,
          borderBottom: "1px solid #E0E0E0",
          backgroundColor: "#63B4FF33",
          borderRadius: "10px",
        }}
      >
        <Box
          style={{
            fontWeight: "bold",
            fontSize: "1rem",
            color: "#2979C3",
          }}
        >
          {t("safe-birth-control-form.medication-necessary")}
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        container
        spacing={3}
        sx={{ display: "flex", flexWrap: "wrap", marginBottom: "10px" }}
      >
        <Grid item sm={6} xs={12} md={4} xl={2}>
          <ByzTitleAndInputBox title={t("safe-birth-control-form.antibiotic")}>
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={2}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.magnesium-sulfate")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={2}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.antihypertensive-treatment")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={2}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.breastfeeding")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={2} container>
          <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
            <ByzMuiCheckBox />
            <ByzMuiTypography
              sx={{
                textAlign: "left",
              }}
              fontWeight={400}
              fontSize={"5px"}
            >
              {t("safe-birth-control-form.dangerous-situation")}
            </ByzMuiTypography>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          margin: "8px",
          p: 2,
          borderBottom: "1px solid #E0E0E0",
          backgroundColor: "#63B4FF33",
          borderRadius: "10px",
        }}
      >
        <Box
          style={{
            fontWeight: "bold",
            fontSize: "1rem",
            color: "#2979C3",
          }}
        >
          {t("safe-birth-control-form.baby-info")}
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        container
        spacing={3}
        sx={{ display: "flex", flexWrap: "wrap", marginBottom: "10px" }}
      >
        <Grid item sm={6} xs={12} md={4} xl={2}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.shipment-required")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          margin: "8px",
          p: 2,
          borderBottom: "1px solid #E0E0E0",
          backgroundColor: "#63B4FF33",
          borderRadius: "10px",
        }}
      >
        <Box
          style={{
            fontWeight: "bold",
            fontSize: "1rem",
            color: "#2979C3",
          }}
        >
          {t("safe-birth-control-form.medication-necessary")}
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        container
        spacing={3}
        sx={{ display: "flex", flexWrap: "wrap", marginBottom: "10px" }}
      >
        <Grid item sm={6} xs={12} md={4} xl={2}>
          <ByzTitleAndInputBox title={t("safe-birth-control-form.antibiotic")}>
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={2}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.anti-retroviral")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={3}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.care-monitoring")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid item sm={6} xs={12} md={4} xl={3}>
          <ByzTitleAndInputBox
            title={t("safe-birth-control-form.care-monitoring")}
          >
            <ByzMuiSelect
              sx={{ ml: "8px" }}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label="" variant="outlined" />
              )}
              options={[]}
              color="primary"
              label={t("partograf-form.chose")}
              placeholder={t("partograf-form.chose")}
            />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>

      <Grid
        item
        sm={12}
        xs={12}
        md={12}
        xl={12}
        sx={{
          margin: "8px",
          p: 1,
          borderBottom: "1px solid #F4F7FE",
          backgroundColor: "#F4F7FE",
        }}
      ></Grid>
      <ByzMuiTypography
        sx={{
          margin: "8px",
        }}
        fontWeight={400}
        fontSize={"4px"}
        color={"red"}
      >
        <Grid item sm={12} xs={12} md={12} xl={12}>
          {t("safe-birth-control-form.note-area")}
        </Grid>
      </ByzMuiTypography>
    </Card>
  );
}

export default PageThere;
